import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row, Col } from 'antd';
import { partnerTypes } from 'utils/app-configs';
import { Div, Flex, FormItem, Button, Icon, Dropdown } from 'ui';
import SearchInput from '../../../search/components/search-input';


const Buttons = styled(Div)`
  > button {
    margin-right: 5px;
  }
`;

const PartnerInfo = styled(Flex)`
  padding: 5px 0;

  .highlight {
    font-weight: 700;
    color: ${p => p.theme.colors.theme};
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 26px;
  color: ${p => p.theme.colors.themeSecondary};
`;

const StyledRow = styled(Row)`
  font-size: 16px;
  margin-top: 40px;
  color: ${p => p.theme.colors.themeSecondary};
`;


const SimpleChangePartnerForm = ({
  partnerValidator,
  canSearch,
  order,
  data,
  type,
  renderLine,
  isSaving,
  isNew,
  engineer,
  preferredEngineer,
  lastVisitEngineer,
  intl,
  selectedPartner,
  handleSelect,
  gotoDetails,
  scopeWide = false,
  handleClear,
  ...rest
}) => {
  const filters = scopeWide ?
    {
      partnerFunction: type,
    } :
    {
      partnerFunction: type,
      entityId: order.id,
    };
  return (
    <>
      <Div width={'70%'} marginBottom={15} marginTop={50}>
        <FormItem label={`${name}`}>
          {partnerValidator(
            canSearch ?
              <SearchInput
                allowClear={true}
                type='partner'
                filters={filters}
                handleSelect={handleSelect}
                onClear={handleClear}
                {...rest}
              /> :
              <Dropdown
                placeholder={intl.formatMessage({
                  id: 'partners.SELECT_PARTNER',
                })}
                values={data?.map(d => ({
                  ...d,
                  displayLine: d.isDefault ? `(Default) ${d.line1}` : d.line1,
                }))}
                disabled={!data || !Object.keys(data).length}
                onChange={handleSelect}
                valueKey='id'
                valueLabel='displayLine'
              />,
          )}
        </FormItem>
        {selectedPartner &&
          <PartnerInfo fdc>
            {renderLine(selectedPartner.line2, selectedPartner.line2Icon)}
            {renderLine(selectedPartner.line3, selectedPartner.line3Icon)}
            {renderLine(selectedPartner.line4, selectedPartner.line4Icon)}
            {renderLine(selectedPartner.line5, selectedPartner.line5Icon)}
            {renderLine(selectedPartner.line6, selectedPartner.line6Icon)}
          </PartnerInfo>
        }
      </Div>
      <Buttons>
        <Button onClick={gotoDetails}>
          <FormattedMessage id='partners.CANCEL_BTN' />
        </Button>
        <Button
          type='secondary'
          htmlType='submit'
          loading={isSaving}
          disabled={canSearch ?
            !selectedPartner || !Object.keys(selectedPartner).length :
            !data || !Object.keys(data).length
          }
        >
          {isNew === 'true'
            ? `${intl.formatMessage({ id: 'partners.SAVE_BTN_NEW' })} ${name.toUpperCase()}`
            : `${intl.formatMessage({ id: 'partners.SAVE_BTN_EDIT' })} ${name.toUpperCase()}`}
        </Button>
      </Buttons>
      {
        type === partnerTypes.SHIPTO && <StyledRow>
          <Col span={1}>
            <StyledIcon type='info-circle' />
          </Col>
          <Col span={23}>
            <p>
              {engineer && intl.formatMessage(
                { id: 'partners.CURRENT_ENGINEER' },
                { engineer },
              )}
            </p>
            <p>
              {preferredEngineer && intl.formatMessage(
                { id: 'partners.PREFERRED_ENGINEER' },
                { engineer: preferredEngineer },
              )}
            </p>
            <p>
              {lastVisitEngineer && intl.formatMessage(
                { id: 'partners.LAST_VISIT_ENGINEER' },
                { engineer: lastVisitEngineer },
              )}
            </p>
          </Col>
        </StyledRow>
      }
    </>
  );
};
SimpleChangePartnerForm.propTypes = {
  partnerValidator: PropTypes.func,
  canSearch: PropTypes.bool,
  order: PropTypes.object,
  data: PropTypes.object,
  isSaving: PropTypes.bool,
  isNew: PropTypes.bool,
  engineer: PropTypes.string,
  preferredEngineer: PropTypes.string,
  lastVisitEngineer: PropTypes.string,
  intl: PropTypes.object,
  selectedPartner: PropTypes.string,
  renderLine: PropTypes.func,
  type: PropTypes.string,
  handleSelect: PropTypes.func,
  gotoDetails: PropTypes.func,
  scopeWide: PropTypes.bool,
  handleClear: PropTypes.func,
};

export default injectIntl(SimpleChangePartnerForm);
